import { useRef, useEffect } from "react";

const usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

const capitalizeString = (sentence) => {
  if (isEmptyString(sentence)) {
    return "";
  }
  const words = sentence.split(" ");
  const capitalizedWords = words.map(
    (word) => word.charAt(0).toUpperCase() + word.slice(1)
  );
  return capitalizedWords.join(" ");
};

const isEmptyString = (value) =>
  value === "" || value === null || value === undefined;

export { usePrevious, capitalizeString, isEmptyString };
